module.exports = __webpack_public_path__ + "static/media/Informationicon03@3x.5607d4c0.png";